import React, {useEffect, useState} from 'react'
import {toast} from 'react-toastify'
import {useAuthClient} from '../../../../utils/use-auth-client'
import {KP11LinkCouponService} from './kp11-coupon-service'
import {
  KP11PromotionsSearchDropDownStyle,
  KP11PromotionsStyle,
} from '../kp-11Link-order-summary/kp-11Link-order-summary-styles'
import {isCartEmpty} from './kp11-utility'
import {kpMagnifyingSearchIcon} from '../../../../assets'

export default function KP11LinkPromotions({
  allCoupons,
  thryvAccount,
  cartCentersAndApps,
  fetchAndApplyPromoCode,
  removeCoupon,
}) {
  const client = useAuthClient()
  const selectedCountry = 'US'

  const [searchText, setSearchText] = useState('')
  const [showPopup, setShowPopup] = useState(false)
  const [searchResultPromos, setSearchResultPromos] = useState([])
  const [maxAllowedCoupons, setMaxAllowedCoupons] = useState(0)

  useEffect(async () => {
    // fetch the max number of manual coupons allowed
    let response = await client(
      'keappartner/fetchConfigLookupValue/maxAllowedManualCoupons',
    )
    setMaxAllowedCoupons(response?.data[0]?.value)
    console.log('maxAllowedCoupons :: ', maxAllowedCoupons)
  }, [])

  console.log('Manual coupons count :: ', allCoupons?.promotions?.length)
  console.log('maxAllowedCoupons :: ', maxAllowedCoupons)
  console.log(
    'maxAllowedCoupons :: ',
    maxAllowedCoupons >= allCoupons?.promotions?.length,
  )
  // Search coupons
  const handleSearch = async () => {
    if (!searchText.trim()) return
    try {
      const res = await KP11LinkCouponService.fetchPromoCodeBySearchText(
        client,
        searchText,
        selectedCountry,
      )
      setSearchResultPromos(res || [])
    } catch (err) {
      console.error('Error fetching coupons', err)
      setSearchResultPromos([])
    } finally {
      setShowPopup(true)
    }
  }

  // Validate & apply promo
  const handleApplyCoupon = async promo => {
    try {
      const codes = [
        ...(cartCentersAndApps.centers?.map(c => c.code) || []),
        ...(cartCentersAndApps.apps?.map(a => a.code) || []),
      ]

      // Add addon codes for bundle coupon
      if (cartCentersAndApps.apps && cartCentersAndApps.apps.length > 0) {
        for (let app of cartCentersAndApps.apps) {
          if (app.addons && app.addons.length > 0) {
            for (let addon of app.addons) {
              codes.push(addon.code)
            }
          }
        }
      }

      // Check if coupon is already added to the order(existing transaction)
      if (
        !(
          allCoupons &&
          allCoupons.promotions &&
          allCoupons.promotions.find(c => c.code === promo.coupon_code)
        )
      ) {
        console.log('thryvAccount :: ', thryvAccount)
        let recurlyValidationError = false
        if (thryvAccount?.recurlyAccount?.code) {
          // Fetch the active coupon redemptions from recurly
          const existingCoupons = await client(
            `accounts/5/coupon-redemptions?thryvId=${thryvAccount?.recurlyAccount?.code}`,
          )
          let activeCouponCodes = existingCoupons.map(coupon => coupon.code)
          console.log('activeCouponCodes : ', activeCouponCodes)
          // Check if coupon being applied is already applied in recurly
          if (activeCouponCodes.includes(promo.coupon_code)) {
            toast.error(
              'Oops! Looks like these coupons are already applied to the client’s account, so they’ll be removed from this order. Don’t worry, the right discounts will still apply when their payment is processed',
            )
            recurlyValidationError = true
          }
          // Check if coupon being applied is incompatible with any already applied coupon in recurly
          let incompatibleCoupons = promo.incompatibles?.split(',')
          if (
            incompatibleCoupons &&
            incompatibleCoupons.length > 0 &&
            incompatibleCoupons.some(incompatibleCoupon =>
              activeCouponCodes.includes(incompatibleCoupon),
            )
          ) {
            toast.error(
              'The coupon you are trying to apply can not be combined with an existing coupon on your account. Coupon not applied.',
            )
            recurlyValidationError = true
          }
        }

        if (!recurlyValidationError) {
          // Bundle coupon validation based on plans in the cart
          if (
            promo.bundle_combinations &&
            promo.bundle_combinations.length > 0
          ) {
            let isValidBundle = false
            for (const bundleCombination of promo.bundle_combinations) {
              const requiredCodes = bundleCombination.split(',')
              const allCodesPresent = requiredCodes.every(code =>
                codes.includes(code),
              )
              if (allCodesPresent) {
                isValidBundle = true
                break
              }
            }
            if (!isValidBundle) {
              // toast.warn(
              //   'Oops! Some items in your cart don’t qualify for this bundle coupon. Please update your cart to continue.',
              // )
              alert(
                'Oops! Some items in your cart don’t qualify for this bundle coupon. Please update your cart to continue.',
              )
              resetSearch()
              // return
            }
          }
          const response = await KP11LinkCouponService.validateCouponByPlans(
            client,
            promo.coupon_code,
            codes,
            selectedCountry,
          )

          if (response?.isValid) {
            fetchAndApplyPromoCode({
              ...response,
              code: promo.coupon_code,
            })
            // Check for incompatible coupons for the newly selected coupon and remove them from the current order cart
            let incompatibleCoupons = promo.incompatibles?.split(',')
            if (incompatibleCoupons && incompatibleCoupons.length > 0) {
              incompatibleCoupons.forEach(coupon => removeCoupon(coupon))
            }
          } else {
            toast.error('Invalid coupon : ' + promo.coupon_code)
            console.log('Invalid coupon', promo.coupon_code)
          }
        }
      }
    } catch (err) {
      console.log('Error validating coupon', err)
      toast.error('Error validating coupon.')
    } finally {
      resetSearch()
    }
  }

  const resetSearch = () => {
    setShowPopup(false)
    setSearchText('')
  }

  return (
    <KP11PromotionsStyle>
      <div
        className="search-field-wrap"
        hidden={maxAllowedCoupons <= allCoupons?.promotions?.length}
      >
        <input
          className="search-input"
          type="text"
          placeholder="Promo Code"
          value={searchText}
          onChange={e => setSearchText(e.target.value)}
        />
        {searchText && (
          <div
            className="search-act-btn clear-input-btn"
            onClick={() => setSearchText('')}
            style={{cursor: 'pointer'}}
          >
            x
          </div>
        )}
        <div
          className="search-act-btn search-icon-btn"
          onClick={handleSearch}
          disabled={isCartEmpty(cartCentersAndApps)}
        >
          <img src={kpMagnifyingSearchIcon} alt="search icon button" />
        </div>
      </div>

      {showPopup && (
        <KP11PromotionsSearchDropDownStyle>
          <div className="dp-header">
            <div className="dp-header-btn" onClick={resetSearch}>
              x
            </div>
          </div>

          {(!searchResultPromos || searchResultPromos.length === 0) && (
            <div className="dp-coupon-item">No coupons found.</div>
          )}

          {searchResultPromos.map(promo => (
            <div
              key={promo.coupon_code}
              onClick={() => handleApplyCoupon(promo)}
              className="dp-coupon-item"
            >
              <div className="dp-coupon-item-name">
                {promo.desc || promo.coupon_code}
              </div>
              <div className="dp-coupon-item-act-btn">Apply</div>
            </div>
          ))}
        </KP11PromotionsSearchDropDownStyle>
      )}
    </KP11PromotionsStyle>
  )
}
